import { Component, input } from '@angular/core';

/**
 * The AOV free product (travel pouch) card of the cart, order_flow_header variant.
 * Rendered at the TOP of the cart list; the legacy variant stays inline in cart.html
 * and is rendered last. Purely presentational — the free product has no quantity
 * controls and no remove action.
 */
@Component({
  selector: 'app-cart-free-product-card',
  templateUrl: './cart-free-product-card.component.html',
})
export class CartFreeProductCardComponent {
  image = input<string>('');
  title = input<string>('');
  /** e.g. "20 gms" — already formatted by the host. */
  quantityLabel = input<string>('');
  /** Struck-through MRP shown next to the FREE label; hidden when absent. */
  mrp = input<number>();
}
